export default __webpack_public_path__ + "static/media/sub-category-musicAndArts-artStudio.e9a1e50a.jpg";